import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DashboardService extends CoreHttpService {
   private dashboardUrl: string = `${environment.apiUrl}/Dashboard`;
   private vobUrl: string = `${environment.apiUrl}/VOBService`;
   private facilityMasterUrl: string = `${environment.apiUrl}/FacilityMaster`;
   private authUrl: string = `${environment.apiUrl}/Authorization`;

  constructor(
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }

  //Frequency List by Facility
  getFacilityFrequencyByFacilityId(params: any) {
    return this.postParams(`${this.facilityMasterUrl}/GetFacilityFrequencyByFacilityId`, "", params);
  }

  getFacilityAndCarrierForFilterData(): Observable<any> {
    return this.get(`${this.dashboardUrl}/GetFacilityAndCarrierForFilterData`);
  }

  getVobMails(requestModel: any): Observable<any> {
    return this.post(`${this.vobUrl}/GetVobMails`, requestModel);
  }

  //Authorization - UR
  getAuthDashboardForSpecialist(requestModel: any) {
    return this.post(`${this.authUrl}/GetAuthDashboardForSpecialist`, requestModel);
  }

  getAuthorizationMails(requestModel: any): Observable<any> {
    return this.post(`${this.authUrl}/GetAuthorizationMails`, requestModel);
  }
}